import React, { useEffect, useState } from "react";
import {
  NavLink,
  Outlet,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";

//Jds
import {
  Button,
  Container,
  Icon,
  InputToggle,
  Notifications,
  Skeleton,
  Text,
} from "@jds/core";

//css
import classes from "./CommonLayout.module.css";
// Mui
import { Box, FormControlLabel, Stack, Switch } from "@mui/material";
//img
// import invitationImg from "../../assets/png/invitation-img.png";
// Local
import EventBanner from "../UI/EventBanner";
import EventDescriptionCard from "../UI/Cards/EventDescriptionCard";
import useApiHttp from "../../hooks/use-http";
import {
  GOOGLE_MAP_API_KEY,
  addParamsURL,
  baseToImg,
  downloadQrImage,
} from "../../util/helper";
import { useDispatch } from "react-redux";
import { setSidebarDetails } from "../../store/state-slices/eventDetails";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import PageLoader from "../UI/Loader/PageLoader";
import JdsModal from "../UI/JdsModal";
import decryptUrl from "../../util/img-decryption";

const libraries = ["places"];

export default function CommonLayout(props) {
  const { id: eventId } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [eventDetails, setEventDetails] = useState();
  const [eventDes, setEventDes] = useState();
  const [eventRecall, setEventRecall] = useState(true);
  const [previewModalCls, setPreviewModalCls] = useState(true);
  const [locationCoordinate, setLocationCoordinate] = useState(null);
  const [isAutoApproval, setIsAutoApproval] = useState(false);
  const [isAutoApprovalModalClose, setIsAutoApprovalModalClose] =
    useState(true);
  const isEventDetailPage = window.location.pathname
    .split("/")
    .join(" ")
    .includes("event-detail");

  const { sendRequest: getEventDetails, isLoading: eventDetailsLoading } =
    useApiHttp();
  const {
    sendRequest: updateDescription,
    isLoading: isUpdatingUserDescription,
  } = useApiHttp();
  const { sendRequest: bannerUpdate, isLoading: isUpdatingBanner } =
    useApiHttp();

  const { sendRequest: makeEventPublicApi, isLoading: isAutoApprovalLoading } =
    useApiHttp();

  const culumData = (data) => {
    dispatch(setSidebarDetails({ eventDetails: data?.data }));
    setEventDetails(data?.data);
    setEventDes(data?.data?.description);
    setLocationCoordinate({
      lat: parseFloat(data?.data?.locationLatitude),
      lng: parseFloat(data?.data?.locationLongitude),
    });
    setIsAutoApproval(data?.data?.isAutoApproval);
  };

  const { isLoaded } = useJsApiLoader({
    // id: "google-map-script",
    googleMapsApiKey: GOOGLE_MAP_API_KEY,
    libraries,
  });

  useEffect(() => {
    getEventDetails(
      {
        url: `event/get-event/${eventId}`,
        method: "GET",
      },
      culumData,
      () => {},
      () => {},
    );
  }, [eventRecall, eventId]);

  return (
    <>
      {!eventDetailsLoading ? (
        <>
          {isEventDetailPage && (
            // <Container direction="column" gap={24} fullWidth >
            <div className={classes["wrapper"]}>
              {/* {eventDetails?.userRole === "ADMIN" && (
                // <InputToggle
                //   label="Public Event"
                //   checked={false}
                //   onChange={(e) => {
                //     setIsAutoApproval(false);
                //     setIsAutoApprovalModalClose(false);
                //   }}
                // />
                <FormControlLabel
                  checked={isAutoApproval}
                  control={<Switch />}
                  label={<Text text="Public Event" color="primary_grey_80" />}
                  labelPlacement="start"
                  onChange={() => setIsAutoApprovalModalClose(false)}
                />
              )} */}
              <EventBanner
                bannerUpdate={bannerUpdate}
                eventDate={eventDetails?.startDate}
                eventTime={eventDetails?.time}
                // bannerImage={
                //   eventDetails?.bannerimage
                //     ? baseToImg(eventDetails?.bannerimage)
                //     : ""
                // }
                bannerImage={
                  eventDetails?.bannerimage ? eventDetails?.bannerimage : ""
                }
                eventDescription={eventDes}
                eventId={eventId}
                eventRecall={() => {
                  setEventRecall((prev) => !prev);
                }}
                eventDetails={eventDetails}
                watermarkModalOpen={location?.state?.isWatermarkModalOpen}
              />

              <div
                className={classes["eventdetails-content"]}
                style={{
                  display: `${
                    eventDetails?.userRole !== "PHOTOGRAPHER" ? "grid" : "flex"
                  }`,
                  gridTemplateColumns: "1fr 1fr 1fr",
                  // gridTemplateRows: "304px",
                  width: "100%",
                  justifyContent: `${
                    eventDetails?.userRole !== "PHOTOGRAPHER"
                      ? ""
                      : "space-between"
                  }`,
                }}>
                <div
                  style={{
                    borderRadius: "10px",
                    height: "100%",
                    // boxShadow: " 0px 4px 16px 0px #00000014",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}>
                  <Container
                    direction="column"
                    gap={8}
                    flex={1}
                    justifyContent="space-between"
                    style={{ maxWidth: "584px" }}
                    fullWidth>
                    <Text
                      text="Event Location"
                      appearance="body-m-bold"
                      color="primary_grey_80"
                    />
                    <Container
                      fullWidth
                      direction="column"
                      justifyContent="space-between"
                      gap={4}
                      style={{
                        overflow: "hidden",
                        borderRadius: "16px",
                        border: "1px solid var(--color-primary-grey-40)",
                      }}>
                      <Container
                        direction="column"
                        justifyContent="space-between"
                        gap={"16px"}
                        fullWidth>
                        {isLoaded ? (
                          <GoogleMap
                            center={locationCoordinate}
                            zoom={15}
                            mapContainerStyle={{
                              width: `${
                                eventDetails?.userRole !== "PHOTOGRAPHER"
                                  ? "100%"
                                  : "650px"
                              }`,
                              height: "224px",
                            }}
                            options={{
                              disableDefaultUI: true, // Disables all default controls
                              zoomControl: false, // Disables zoom control
                              streetViewControl: false, // Disables Street View control
                              mapTypeControl: false, // Disables map type control
                              fullscreenControl: false, // Disables fullscreen control
                              gestureHandling: "none", // Disables all user gestures
                            }}>
                            {locationCoordinate && (
                              <Marker position={locationCoordinate} />
                            )}
                          </GoogleMap>
                        ) : (
                          <Skeleton shape="rectangle" />
                        )}
                      </Container>
                      <Container
                        direction="column"
                        gap={8}
                        style={{ padding: "12px" }}>
                        <Text
                          text="Address"
                          appearance="body-m-bold"
                          color="primary_grey_80"
                        />
                        <Text
                          text={eventDetails?.locationName || "Address"}
                          appearance="body-m"
                        />
                      </Container>
                    </Container>
                  </Container>
                </div>
                <div>
                  <p className={classes["guides-card"]}>
                    {eventDetails?.userRole !== "PHOTOGRAPHER" ? (
                      <Text
                        text="Guides"
                        appearance="body-m-bold"
                        color="primary_grey_80"
                      />
                    ) : (
                      ""
                    )}
                  </p>
                  <div
                    className={classes["guides-content"]}
                    style={{
                      paddingInline: "40px",
                      paddingTop: "30px",
                      display: "flex",
                      flexDirection: "column",
                      // gap: "16px",
                      justifyContent: "space-between",
                      height: "354px",
                    }}>
                    {eventDetails?.userRole !== "PHOTOGRAPHER" ? (
                      <Button
                        iconLeft={"IcGroup"}
                        icon={"IcArrowNext"}
                        kind="secondary"
                        label="Invite Guests"
                        onClick={() => {
                          navigate(`/home/events/guests/${eventId}`, {
                            state: { addGuest: true },
                          });
                        }}
                        fullWidth
                      />
                    ) : (
                      ""
                    )}
                    <Button
                      iconLeft={"IcPhoto"}
                      icon={"IcArrowNext"}
                      kind="secondary"
                      label="Upload Photos"
                      onClick={() => {
                        navigate(`/home/events/albums/${eventId}`, {
                          state: { newFolder: true },
                        });
                      }}
                      fullWidth
                    />
                    {/* <div
                      onClick={() => {
                        navigate(`/home/events/guests/${eventId}`, {
                          state: { addGuest: true },
                        });
                      }}
                      style={{
                        cursor: "pointer",
                      }}
                      className={classes["bg-shadow"]}
                    >
                      <Container
                        fullWidth
                        direction="row"
                        verticalAlign="center"
                      >
                        <Text
                          text="Go to users and start inviting guests"
                          appearance="body-m-bold"
                          color="primary-50"
                        />
                        <Icon ic={"IcArrowNext"} />
                      </Container>
                    </div> */}
                    {/* <div
                      onClick={() => {
                        navigate(`/home/events/albums/${eventId}`, {
                          state: { newFolder: true },
                        });
                      }}
                      style={{
                        cursor: "pointer",
                      }}
                      className={classes["bg-shadow"]}
                    >
                      <Container
                        fullWidth
                        direction="row"
                        verticalAlign="center"
                      >
                        <Text
                          text="Go to photos and start uploading albums"
                          appearance="body-m-bold"
                          color="primary-50"
                        />
                        <Icon ic={"IcArrowNext"} />
                      </Container>
                    </div> */}
                    <Container
                      fullWidth
                      direction="row"
                      horizontalAlign="center"
                      style={{
                        alignSelf: "end",
                      }}>
                      {eventDetails?.userRole !== "PHOTOGRAPHER" ? (
                        <Button
                          label="Preview Invitation"
                          onClick={() => {
                            setPreviewModalCls(false);
                          }}
                          fullWidth
                        />
                      ) : (
                        ""
                      )}
                      <JdsModal
                        header={"Preview Invitation"}
                        close={previewModalCls}
                        onClose={() => {
                          setPreviewModalCls(true);
                        }}
                        size="m">
                        {!previewModalCls && (
                          <PreviewInvitation eventDetails={eventDetails} />
                        )}
                      </JdsModal>
                    </Container>
                  </div>
                </div>
                {eventDetails?.userRole !== "PHOTOGRAPHER" ? (
                  <div
                    style={{
                      borderRadius: "10px",
                      // boxShadow: " 0px 4px 16px 0px #00000014",
                    }}>
                    <Container
                      direction="column"
                      fullWidth
                      gap={8}
                      horizontalAlign="center">
                      <Container
                        style={{
                          width: "100% ",
                        }}
                        direction="row"
                        horizontalAlign="space-between">
                        <Text
                          text="QR Image"
                          appearance="body-m-bold"
                          color="primary_grey_80"
                        />
                        <span
                          onClick={() => {
                            downloadQrImage(
                              eventDetails?.qrCodeImage,
                              eventDetails,
                            );
                          }}
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            gap: "5px",
                          }}>
                          <Text
                            text="Download"
                            appearance="body-m-bold"
                            color="primary-50"
                          />
                          <Icon ic={"IcDownload"} />
                        </span>
                      </Container>
                      <Box
                        sx={{
                          border: "1px solid var(--color-primary-grey-40)",
                          width: "100%",
                          textAlign: "center",
                          padding: "24px 8px",
                          // backgroundColor: "var(--color-primary-grey-20)",
                          borderRadius: "16px",
                          height: "344px",
                        }}>
                        <img
                          src={baseToImg(eventDetails?.qrCodeImage)}
                          alt="qr code"
                          style={{
                            // height: "100%",
                            width: "200px",
                          }}
                        />

                        <Container
                          horizontalAlign="center"
                          fullWidth
                          style={{ marginTop: "24px" }}>
                          <Text
                            text="Event Code:"
                            appearance="body-m-bold"
                            color="primary_grey_80"
                          />
                          <Text
                            text={eventDetails?.uniquePin}
                            appearance="body-m"
                            color="primary_50"
                          />
                        </Container>

                        <Container
                          horizontalAlign="center"
                          fullWidth
                          style={{ marginTop: "24px" }}>
                          <span
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              fontSize: "18px",
                              color: "var(--color-primary-grey-80)",
                              fontWeight: "700",
                            }}>
                            Event Link:
                          </span>
                          <span
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              cursor: "pointer",
                              gap: "4px",
                            }}
                            onClick={() => {
                              navigator.clipboard
                                .writeText(
                                  `${process.env.REACT_APP_JIOCLOUD_LANDING_URL}/events/sign-up?event_id=${eventDetails?.id}`,
                                )
                                .then(() => {
                                  Notifications.toast.success({
                                    id: "copy-link",
                                    title: "Link copied to clipboard",
                                  });
                                })
                                .catch((err) => {});
                            }}>
                            {/* <Text
                              text={
                                eventDetails?.name 
                               
                              }
                              appearance="body-m"
                              color="primary_50"
                              maxLines={1}
                            /> */}
                            <span
                              style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                fontSize: "18px",
                                color: "var(--color-primary-50)",
                                fontWeight: "500",
                                textOverflow: "ellipsis",
                                fontFamily: "var(--font-families-body-m)",
                              }}>
                              {eventDetails?.name}
                            </span>
                            <Icon ic={"IcLink"} size="m" />
                          </span>
                          {/* <span>{eventDetails?.name}</span> */}
                        </Container>
                      </Box>
                    </Container>
                  </div>
                ) : (
                  ""
                )}
              </div>
              {/* </Container> */}
            </div>
          )}
          <Box mt={isEventDetailPage && 6}>
            <Outlet context={[eventDetails]} />
          </Box>
        </>
      ) : (
        <PageLoader open={eventDetailsLoading} />
      )}

      <PageLoader open={isUpdatingUserDescription || isUpdatingBanner} />

      <JdsModal
        size="m"
        header={`Are you sure you want to make this event ${
          !isAutoApproval ? "public" : "private"
        } ?`}
        kind="dialog"
        primaryCTA={{
          title: "Okay",
        }}
        secondaryCTA={{
          title: "Cancel",
        }}
        close={isAutoApprovalModalClose}
        onClose={() => setIsAutoApprovalModalClose(true)}
        onPrimaryClick={() => {
          makeEventPublicApi(
            {
              url: "event/switch-auto-approval",
              method: "PATCH",
              body: {
                id: eventId,
                isAutoApproval: !isAutoApproval,
              },
            },
            (data) => {},
            (data) => {
              setIsAutoApprovalModalClose(true);
              Notifications.toast.success({
                id: "switch-approval",
                title: data?.message,
              });
              setIsAutoApproval((prev) => !prev);
            },
          );
        }}
        onSecondaryClick={() => setIsAutoApprovalModalClose(true)}
        primaryCtaDisabled={isAutoApprovalLoading}>
        <Text
          text={
            !isAutoApproval
              ? "All the registered users will get auto approval for this event!"
              : "The registered users have to be approved manually!"
          }
        />
      </JdsModal>
    </>
  );
}

const PreviewInvitation = ({ eventDetails }) => {
  return (
    <>
      <div style={{ display: "flex", gap: "10px", flexDirection: "column" }}>
        {/* <img src={invitationImg} /> */}
        <img
          src={
            eventDetails?.bannerimage
              ? addParamsURL(decryptUrl(eventDetails?.bannerimage), {
                  size: "s",
                })
              : ""
          }
        />
        <p style={{ fontSize: "24px", fontWeight: "900" }}>You're Invited!</p>
        <div>
          <p
            style={{
              fontSize: "16px",
              fontWeight: "500",
            }}>{`We are thrilled to extend an exclusive invitation to you for ${eventDetails?.name} via JioAICloud, your personalized event companion. Your presence would add immense value to the event, and we genuinely hope you can join us.`}</p>
          <p style={{ fontSize: "16px", fontWeight: "700", marginTop: "10px" }}>
            Event Details:
          </p>
          <div
            style={{
              boxShadow:
                " rgba(0, 0, 0, 0.02) 0px 1px 3px 0px , rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
              padding: "15px",
              borderRadius: "10px",
              marginTop: "5px",
            }}>
            <table>
              <tr>
                <td style={{ whiteSpace: "nowrap", width: "100px" }}>
                  Event Name
                </td>
                <td style={{ paddingLeft: "8px" }}> : {eventDetails.name}</td>
              </tr>
              {/* <tr>
                <td>Organized By</td>
                <td>balaji birthday</td>
              </tr> */}
              <tr>
                <td>
                  {eventDetails?.endDate === eventDetails?.startDate
                    ? "Date "
                    : "From "}
                </td>
                <td style={{ paddingLeft: "8px" }}>
                  {" "}
                  : {eventDetails?.startDate}
                </td>
              </tr>
              <tr>
                <td>
                  {eventDetails?.endDate === eventDetails?.startDate
                    ? "Time "
                    : "To "}
                </td>
                <td style={{ paddingLeft: "8px" }}>
                  :{" "}
                  {eventDetails?.endDate === eventDetails?.startDate
                    ? eventDetails?.time
                    : eventDetails?.endDate}
                </td>
              </tr>
              <tr>
                <td>Venue</td>
                <td style={{ paddingLeft: "8px" }}>
                  : {eventDetails?.locationName}
                </td>
              </tr>
            </table>
          </div>
          <p style={{ fontSize: "16px", fontWeight: "700", marginTop: "10px" }}>
            Register QR:
          </p>
          <div style={{ marginInline: "auto", width: "200px" }}>
            <img
              src={baseToImg(eventDetails?.qrCodeImage)}
              style={{ width: "200px" }}
            />
          </div>
          <Stack
            my={1}
            direction="row"
            gap={1}
            sx={{
              "& > a": {
                color: "var(--color-primary-50)",
                fontFamily: "var(--font-families-body-sbold)",
              },
              "& .text-atom": {
                whiteSpace: "nowrap",
              },
            }}>
            <Container
              horizontalAlign="center"
              fullWidth
              style={{ marginTop: "24px" }}>
              <span
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  fontSize: "18px",
                  color: "var(--color-primary-grey-80)",
                  fontWeight: "700",
                }}>
                Event Link:
              </span>
              <span
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  cursor: "pointer",
                  gap: "4px",
                }}
                onClick={() => {
                  navigator.clipboard
                    .writeText(
                      `${process.env.REACT_APP_JIOCLOUD_LANDING_URL}/events/sign-up?event_id=${eventDetails?.id}`,
                    )
                    .then(() => {
                      Notifications.toast.success({
                        id: "copy-link",
                        title: "Link copied to clipboard",
                      });
                    })
                    .catch((err) => {});
                }}>
                {/* <Text
                              text={
                                eventDetails?.name 
                               
                              }
                              appearance="body-m"
                              color="primary_50"
                              maxLines={1}
                            /> */}
                <span
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    fontSize: "18px",
                    color: "var(--color-primary-50)",
                    fontWeight: "500",
                    textOverflow: "ellipsis",
                    fontFamily: "var(--font-families-body-m)",
                  }}>
                  {eventDetails?.name}
                </span>
                <Icon ic={"IcLink"} size="m" />
              </span>
              {/* <span>{eventDetails?.name}</span> */}
            </Container>
          </Stack>
          <p style={{ fontSize: "16px", fontWeight: "500" }}>
            Note: By confirming your presence, you will gain access to all
            event-related photos presentations, and exclusive content on
            JioAICloud.
          </p>
        </div>
      </div>
    </>
  );
};
